import { ChevronLeftIcon } from '@ordr-as/icons'
import { Link, Navigate, useParams } from 'react-router-dom'
import { FailedPspNotificationDto } from '../../../../generated-api'
import JsonHighlight from 'components/JsonHighlight'
import { formatDateAndTime } from 'utils/stringUtils'
import { Button } from '@ordr-as/umami-react'
import highlightStackTrace from './HighlightStacktrace'
import { useState } from 'react'
import { usePaymentOperations } from '../context/PaymentOperationsContext'
import { extractPaymentReference, extractValue, getReason } from './PspNotificationUtils'

type FailedPspNotificationDetailsProps = {
    failedPspNotifications: FailedPspNotificationDto[]
}
export const FailedPspNotificationDetails = ({ failedPspNotifications }: FailedPspNotificationDetailsProps) => {
    const { pspNotificationId } = useParams<{ pspNotificationId: string }>()
    const notification = failedPspNotifications.find((p) => p.pspNotificationId === Number(pspNotificationId))
    const [isRetrying, setIsRetrying] = useState<boolean>()
    const { retryFailed } = usePaymentOperations()

    const retryNotification = () => {
        if (notification) {
            setIsRetrying(true)
            retryFailed([notification.pspNotificationId])

            setTimeout(() => {
                setIsRetrying(false)
            }, 30000)
        }
    }

    if (!notification) {
        return <Navigate to="/payment-operations/psp-notifications" />
    }

    const reason = getReason(notification)
    const paymentReference = extractPaymentReference(notification)
    const pspReference = extractValue(notification, 'pspReference')

    return (
        <div>
            <div className="rounded-lg bg-brand-white shadow-lg py-4 mt-4 px-5">
                <Link
                    to="../psp-notifications"
                    className="flex items-center text-[#3b82f6] text-sm cursor-pointer pb-4"
                >
                    <ChevronLeftIcon className="mr-2" />
                    Back to list
                </Link>
                <h2 className="text-lg font-semibold pb-2">Payment Details</h2>
                <div className="grid grid-cols-2 gap-4 text-sm">
                    <div className="font-semibold">PspNotificationId:</div>
                    <div>{notification.pspNotificationId}</div>
                    <div className="font-semibold">Payment reference:</div>
                    <div>{paymentReference}</div>
                    <div className="font-semibold">Psp reference:</div>
                    <div>{pspReference}</div>
                    <div className="font-semibold">Reaon:</div>
                    <div>{reason}</div>
                    <div className="font-semibold">Latest failure reason:</div>
                    <div>{notification.latestFailureReason}</div>
                    <div className="font-semibold">type:</div>
                    <div>{notification.type}</div>
                    <div className="font-semibold">Retry count:</div>
                    <div>{notification.retryCount}</div>
                    <div className="font-semibold">Notification timestamp:</div>
                    <div>{formatDateAndTime(notification.pspNotificationTimestamp)}</div>
                    <div className="font-semibold">Updated:</div>
                    <div>{formatDateAndTime(notification.updated)}</div>
                    <div></div>
                    <div>
                        <Button kind="primary" onClick={retryNotification} isDisabled={isRetrying}>
                            Retry
                        </Button>
                    </div>

                    <div className="col-span-2 overflow-auto max-h-[800px]">
                        <h3 className="text-sm font-semibold pb-2">Payload</h3>
                        <JsonHighlight object={JSON.parse(notification.payload ?? '{}')} />
                    </div>
                    <div className="col-span-2 overflow-auto max-h-[1000px]">
                        <h3 className="text-sm font-semibold pb-2">Stack trace</h3>
                        <pre className="bg-brand-accent text-xs font-mono p-3 rounded whitespace-pre-wrap break-words">
                            {highlightStackTrace(notification.stackTrace) || 'No stack trace available'}
                        </pre>
                    </div>
                </div>
            </div>
        </div>
    )
}
